import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CtaButtonProps = {
  label: string;
  sub?: string;
  id?: string;
  className?: string;
};
export function CtaButton({
  label,
  sub,
  id,
  className = ""
}: CtaButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`group mx-auto flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-4 text-center text-white shadow-[0_6px_0_0_#14532d] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-cta-dark active:translate-y-1 active:shadow-[0_2px_0_0_#14532d] focus:outline-none focus-visible:ring-4 focus-visible:ring-sun ${className}`} data-id="element-32" data-mp="cl2cvzoa97jd">
      <span className="flex flex-col items-center" data-id="element-33" data-mp="vbshptxez4ev">
        <span className="font-display text-[17px] font-extrabold uppercase leading-snug tracking-tight sm:text-xl" data-id="element-34" data-mp="19as4sx5a3b8x">
          {label}
        </span>
        {sub && <span className="mt-1 text-xs font-semibold text-white/90 sm:text-sm" data-id="element-35" data-mp="15bazq4trkg4a">{sub}</span>}
      </span>
      <ArrowRightIcon aria-hidden="true" className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-36" data-mp="35yz2wt2cn89y" />
    </a>;
}